import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CurrencyService, LanguageService, OccEndpointsService } from '@spartacus/core';

import { CustomBrandService } from '../services/custom-brand.service';

@Injectable({
  providedIn: 'root'
})
export class CustomSiteContextInterceptor implements HttpInterceptor {
  private activeBrand?: string;
  private activeLang?: string;
  private activeCurr?: string;

  constructor(
    private readonly languageService: LanguageService,
    private readonly currencyService: CurrencyService,
    private readonly brandService: CustomBrandService,
    private readonly occEndpoints: OccEndpointsService
  ) {
    this.languageService.getActive().subscribe((data) => { this.activeLang = data; });
    this.currencyService.getActive().subscribe((data) => { this.activeCurr = data; });
    this.brandService.getActive().subscribe((data) => { this.activeBrand = data; });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(this.occEndpoints.getBaseUrl())) {
      return next.handle(request.clone({
        setParams: this.filterEmptyFields({
          lang: this.activeLang,
          curr: this.activeCurr,
          brand: this.activeBrand
        })
      }));
    }

    return next.handle(request);
  }

  private filterEmptyFields(obj: Record<string, string>): Record<string, string> {
    return Object.entries(obj).reduce(
      (acc, [key, value]) => value ? ({ ...acc, [key]: value }) : acc, {}
    );
  }
}
